/* eslint-disable prefer-destructuring */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck

/* eslint-disable no-restricted-globals */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { colors } from '@hover/blueprint-theme/bauhaus';
import MacheteConstants from '@hoverinc/machete-constants';

import { config } from 'src/config';
import { Menu } from 'src/modules/designStudio/constants';
import {
  changeCameraFocus,
  getFocusOptionsForMenu,
} from 'src/modules/designStudio/helpers/machete';
import type {
  Geometry,
  Metadata,
} from 'src/modules/designStudio/hooks/useFetchModelData';
import type { Machete } from 'src/modules/homeownerApp/components/ThreeDModel/types';
import type { JobThreeDFiles } from 'src/shared/graphql/generated';
import { requestWithRetry } from 'src/shared/utils/request';
import { configureRetry } from 'src/shared/utils/retry';

const getModelData = async (threeDFiles: JobThreeDFiles) => {
  if (threeDFiles.geometryUrl && threeDFiles.metadataUrl) {
    const [geometry, metadata] = await Promise.all([
      requestWithRetry(threeDFiles.geometryUrl).then(
        res => res.json() as Geometry,
      ),
      requestWithRetry(threeDFiles.metadataUrl).then(
        res => res.json() as Metadata,
      ),
    ]);
    return { geometry, metadata };
  }
  return null;
};

const renderMachete = async ({
  canvasRef,
  geometry,
  metadata,
}): Promise<Machete> => {
  const { withRetry } = configureRetry();
  const MacheteDisplay = (
    await withRetry(
      () =>
        // eslint-disable-next-line import/no-extraneous-dependencies
        import(
          /* webpackChunkName: "machete" */
          '@hoverinc/machete-display'
        ),
    )()
  ).default;

  const SHADING_CONFIGS = {
    useSky: false,
    useTerrain: false,
    useShadowMap: false,
    backgroundColor: colors.neutral[100],
    useNavigationControls: false,
    controlOptions: {
      maxPolarAngle: 1.75,
    },
  };

  const display = new MacheteDisplay(
    canvasRef.current, // domElement
    SHADING_CONFIGS, // viewerOptions
    null, // textures
    {
      geometry,
      metadata,
    }, // buildingData
    'scan-3d-model',
    config.VERSION,
    config.NODE_ENV,
  );

  await display.isReady();

  const { viewer, building } = display;

  return { building, viewer };
};

const labelBuilding = building => {
  [...building.features].forEach(feature => {
    feature.outline_color = colors.neutral[600];
    feature.outline_thickness = 0.02;
    feature.display_outline = true;
    feature.color = colors.neutral[0];
  });
};

const focusOnFeature = async (building, viewer, element: FocusElement) => {
  const { focusElement, focusOptions } = await getFocusOptionsForMenu(
    building,
    viewer,
    element,
  );
  const delay = 0;
  void changeCameraFocus(viewer, focusElement, focusOptions, delay);
};

enum FocusElement {
  WALL = Menu.WALL,
  ROOF = Menu.ROOF,
  TRIM = Menu.TRIM,
  SIDING = 'SIDING',
  DOOR = Menu.DOOR,
  WINDOW = Menu.WINDOW,
  SOFFIT = 'SOFFIT',
  FASCIA = 'FASCIA',
  SHUTTERS = 'SHUTTERS',
}

const getLabelIds = (menu: FocusElement) => {
  switch (menu) {
    case FocusElement.WALL:
      return MacheteConstants.WALL_LABELS;
    case FocusElement.ROOF:
      return [MacheteConstants.ROOF_LABEL_ID];
    case FocusElement.TRIM:
      return [
        MacheteConstants.OPENINGS_TRIM_LABEL_ID,
        MacheteConstants.TRIM_LABEL_ID,
      ];
    case FocusElement.SIDING:
      return [
        MacheteConstants.SIDING_ID,
        MacheteConstants.OTHER_SIDING_ID,
        MacheteConstants.SHINGLED_SIDING_ID,
        MacheteConstants.VERTICAL_SIDING_ID,
      ];
    case FocusElement.DOOR:
      return [MacheteConstants.DOOR_LABEL_ID];
    case FocusElement.SOFFIT:
      return [MacheteConstants.SOFFIT_LABEL_ID];
    case FocusElement.WINDOW:
      return [MacheteConstants.WINDOW_LABEL_ID];
    case FocusElement.FASCIA:
      return [MacheteConstants.FASCIA_LABEL_ID];
    case FocusElement.SHUTTERS:
      return [MacheteConstants.SHUTTER_LABEL_ID];
    default:
      return [];
  }
};

const highlightFeature = (building, viewer, focusElement: FocusElement) => {
  building?.getFeatures().forEach(feature => {
    feature.outline_color = colors.neutral[400];
    feature.highlight.config.color = colors.neutral[0];
    feature.highlight.visible = false;
    feature.outline_thickness = 0.02;
  });

  const labels = getLabelIds(focusElement);

  labels.forEach(async label => {
    const features =
      (await building?.findFeaturesByAttributes({
        primary_label: label,
      })) || [];

    features.forEach(feature => {
      feature.outline_color = colors.neutral[600];
      feature.highlight.config.color = colors.neutral[900];
      feature.highlight.visible = true;
      feature.outline_thickness = 0.04;
    });
  });

  void focusOnFeature(building, viewer, focusElement);
};

export {
  renderMachete,
  labelBuilding,
  getModelData,
  focusOnFeature,
  highlightFeature,
  FocusElement,
};
